import React from "react";
import ReactGA from "react-ga4";

const gaPageTracker = (url = "") => {
    // return ReactGA.pageview(url);
    // console.log('tracking page', url)
    // return ReactGA.send({hitType: 'pageview', page: url});
};
export default gaPageTracker;
